<template>
  <select
    :value="activeTab?.to"
    @change="router.push($event.target.value)"
    class="px-2 py-1.5 text-xs font-medium rounded-md border border-stroke-strong dark:border-stroke-strong-dark bg-surface dark:bg-surface-dark text-fg-secondary dark:text-fg-secondary-dark"
  >
    <option v-for="tab in CALENDAR_TABS" :key="tab.to" :value="tab.to">{{ tab.label }}</option>
  </select>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { CALENDAR_TABS } from '@/composables/calendarTabs.js'

const route  = useRoute()
const router = useRouter()
const activeTab = computed(() => CALENDAR_TABS.find(t => route.path.startsWith(t.to)))
</script>
